import React, { useEffect } from 'react';
import { Tabs } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import { fetchWidgetMessages, setActiveTab } from '@store/overviewDashboard/widgetMessageData/actions';
import {
  DevicesTabKey,
  StreamsTabKey,
  ViewersTabKey,
} from '@store/overviewDashboard/widgetMessageData/reducer';
import {
  ovbDeviceMetricsEnabledSelector,
  ovbViewersMetricsEnabledSelector,
} from '@store/common/selectors';
import { setSelectedKPI } from '@store/overviewDashboard/base/actions';
import { kpiMetricSelector } from '@store/overviewDashboard/base/selectors';
import { activeTabSelector } from '@store/overviewDashboard/widgetMessageData/selectors';
import { StreamsTab, DevicesTab, ViewersTab } from './Tabs';
import { TabWrapper } from './styled';

const { TabPane } = Tabs;

const InfoTab = () => {
  const dispatch = useDispatch();
  const showDevicesTab = useSelector(ovbDeviceMetricsEnabledSelector);
  const showViewersTab = useSelector(ovbViewersMetricsEnabledSelector);
  const selectedMetric = useSelector(kpiMetricSelector);
  const activeTab = useSelector(activeTabSelector);

  useEffect(() => {
    dispatch(fetchWidgetMessages());
  }, []);

  const onTabChange = (key) => {
    dispatch(setActiveTab(key));
  };

  const onTabMetricClick = (metric) => {
    dispatch(setSelectedKPI(metric));
  };

  return (
    <TabWrapper>
      <Tabs activeKey={activeTab} onChange={onTabChange} size="small">
        <TabPane tab="Streams" key={StreamsTabKey}>
          <StreamsTab onTabMetricClick={onTabMetricClick} selectedMetric={selectedMetric} />
        </TabPane>
        { showViewersTab ? (
          <TabPane tab="Viewers" key={ViewersTabKey}>
            <ViewersTab />
          </TabPane>
        ) : null
        }
        { showDevicesTab ? (
          <TabPane tab="Devices" key={DevicesTabKey}>
            <DevicesTab />
          </TabPane>
        ) : null
        }
      </Tabs>
    </TabWrapper>
  );
};
export default InfoTab;
